<!--
Author: TangChen
Date: 2018-09-10
Desc: 登录页面，实现手机，证件号登录，由router.js 配置引入
 -->
<template>
    <div class="view-login view">
        <header-com-dc />
        <img class="login-bg" src="../../assets/img/login-bg.png" alt="" />
        <div class="login-main" :class="[singleLoginFlag ? 'flex-d' : 'h545']">
            <div v-if="!singleLoginFlag" class="login-comp-container">
                <div class="login-panel" :style="{ top: login_top + 'px' }">
                    <div class="login-body">
                        <div class="login-cert-type">
                            <div class="left-btn select-btn">个人登录</div>
                            <div class="middle-line"></div>
                            <div class="right-btn">机构登录</div>
                        </div>
                        <div class="login-form">
                            <el-form
                                v-if="!singleLoginFlag"
                                ref="loginForm"
                                :rules="rules"
                                :model="loginForm"
                                label-width="0"
                                v-on:keyup.enter.native="login"
                            >
                                <el-form-item v-if="loginCertType === '1'" label="" prop="phone">
                                    <el-input
                                        v-model.trim="loginForm.phone"
                                        :maxlength="11"
                                        placeholder="请输入手机号码"
                                        prefix-icon="fa fa-mobile"
                                    />
                                </el-form-item>
                                <el-form-item v-if="loginCertType === '1'" label="" prop="smscode">
                                    <el-input
                                        v-model.trim="loginForm.smscode"
                                        class="reset-pwd"
                                        :maxlength="6"
                                        placeholder="请输入验证码"
                                        prefix-icon="fa fa-lock"
                                    >
                                        <span
                                            slot="append"
                                            type="text"
                                            class="reset-btn"
                                            :class="{ grey: count > 0 }"
                                            v-on:click="getVerifyCode"
                                        >
                                            {{ count > 0 ? `重新获取(${count}s)` : "获取验证码" }}
                                        </span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item
                                    v-if="loginCertType === '2'"
                                    label=""
                                    prop="certType"
                                    class="icon-select"
                                >
                                    <i class="fa fa-id-card select-card" aria-hidden="true" />
                                    <el-select
                                        v-model="loginForm.certType"
                                        placeholder="请选择证件类型"
                                        v-on:change="checkCertNoAgain"
                                    >
                                        <el-option
                                            v-for="item in certTypes"
                                            :key="item.subitem"
                                            :label="item.subitemname"
                                            :value="item.subitem"
                                        />
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-if="loginCertType === '2'" label="" prop="certNo">
                                    <el-input
                                        v-model.trim="loginForm.certNo"
                                        :maxlength="20"
                                        :placeholder="
                                            loginForm.certType === '000'
                                                ? '请输入基金账号'
                                                : '请输入证件号码'
                                        "
                                        prefix-icon="fa el-icon-user-solid"
                                    />
                                </el-form-item>
                                <el-form-item
                                    v-if="
                                        loginCertType === '2' &&
                                        $cache.getSysParam('10103010') == '1'
                                    "
                                    label=""
                                    prop="verifyCode"
                                >
                                    <el-input
                                        v-model="loginForm.verifyCode"
                                        placeholder="请输入验证码"
                                        :maxlength="4"
                                        prefix-icon="fa fa-shield"
                                    >
                                        <span slot="append" class="prop-verify">
                                            <img
                                                id="verifyImg"
                                                :src="imgSrc"
                                                v-on:click="refresh"
                                            />
                                        </span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item v-if="loginCertType === '2'" label="" prop="password">
                                    <el-input
                                        v-model.trim="loginForm.password"
                                        type="password"
                                        class="reset-pwd"
                                        :maxlength="32"
                                        placeholder="请输入密码"
                                        prefix-icon="fa fa-lock"
                                        v-on:keydown.native="detectCapsLock"
                                    >
                                        <div
                                            slot="append"
                                            style="
                                                position: relative;
                                                top: 40px;
                                                color: #999;
                                                font-size: 14px;
                                            "
                                            type="text"
                                            class="reset-btn"
                                            v-on:click.once="forgetPwd"
                                        >
                                            忘记密码?
                                        </div>
                                    </el-input>
                                    <div
                                        class="capsLock-tip js-capsLock"
                                        :class="{ hide: !capsLock }"
                                    >
                                        <i class="capsLockTip-triangle" aria-hidden="true" />
                                        大写锁定已打开
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    class="login-btn"
                                    :class="
                                        loginCertType === '2' &&
                                        $cache.getSysParam('10103010') == '1'
                                            ? 'margin-top30'
                                            : 'margin-top50'
                                    "
                                >
                                    <el-button
                                        type="primary"
                                        class="login-n"
                                        :class="span24"
                                        v-on:click="login"
                                    >
                                        登录
                                    </el-button>
                                </el-form-item>
                                <el-form-item class="login-btn">
                                    <el-button
                                        type="null"
                                        class="login-n"
                                        :class="span24"
                                        v-on:click="register"
                                    >
                                        免费注册
                                    </el-button>
                                </el-form-item>
                                <el-form-item class="login-btn">
                                    <div
                                        class="dc-other-container"
                                        :class="
                                            loginCertType === '2' &&
                                            $cache.getSysParam('10103010') == '1'
                                                ? ''
                                                : 'margin-top12'
                                        "
                                    >
                                        <div class="otheritem">登录帮助</div>
                                        <div class="otheritem">安全说明</div>
                                        <div class="otheritem">交易指南</div>
                                    </div>
                                </el-form-item>
                            </el-form>
                            <el-button v-else type="primary" class="login-n" v-on:click="login">
                                登录
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <el-carousel id="carousel" :interval="5000" :height="'468px'">
                <template v-if="!ads || ads.length === '0'">
                    <el-carousel-item>
                        <div class="login-ad">
                            <img
                                src="@/assets/img/login_banner.png"
                                style="height: 100%; width: 100%"
                            />
                        </div>
                    </el-carousel-item>
                </template>
                <template v-else>
                    <el-carousel-item v-for="item in ads" :key="item.imgid">
                        <div class="login-ad">
                            <template v-if="!item.imgid">
                                <img
                                    src="@/assets/img/login_banner.png"
                                    style="height: 100%; width: 100%"
                                />
                            </template>
                            <template v-else>
                                <a
                                    v-if="item.linkurl"
                                    :href="item.linkurl"
                                    :target="item.opentype !== '3' ? '_self' : '_blank'"
                                >
                                    <img
                                        :src="item.imgid"
                                        style="height: 100%; width: 100%"
                                        v-on:error="handleError"
                                    />
                                </a>
                                <div>
                                    <img
                                        :src="item.imgid"
                                        style="height: 100%; width: 100%"
                                        v-on:error="handleError"
                                    />
                                </div>
                            </template>
                        </div>
                    </el-carousel-item>
                </template>
            </el-carousel>
            <div v-if="singleLoginFlag" class="singleLogin">
                <el-button :loading="loading" type="primary" class="login-n" v-on:click="login">
                    登录
                </el-button>
            </div>
            <log />
        </div>

        <usual-problem v-if="!$util.belongHx()"></usual-problem>
        <img-code
            v-if="loginCertType === '1' && !$util.belongHx()"
            :dialog-visible="dialogVisible"
            :biztype="$const.IMG_BIZTYPE.SMSLOGIN"
            v-on:verify-in="sendSms"
        />
    </div>
</template>

<script>
import headerComDc from "@/components/layout/headerDc.vue";
import log from "@/components/misc/log.vue";
import userApi from "@/api/user";
import fundApi from "@/api/fund";
import usualProblem from "@/components/util/usualProblem.vue";
import imgCode from "@/components/layout/imgCode.vue";
export default {
    components: {
        headerComDc,
        log,
        usualProblem,
        imgCode
    },
    data() {
        return {
            imgRefresh: null,
            ad_ratio: 3, // 轮播广告图片的长宽比
            ad_width: 0,
            ad_height: 0, // 轮播广告图片高度，由setPageSize方法计算后赋值
            login_top: "10",
            ads: [],
            loginType: [
                { id: "1", name: "手机号登录" },
                { id: "2", name: "证件号登录" } // 暂不支持其他登录方式
            ],
            /* { id: "1", val: "QQ账号", url: "qq_icon" }, */
            others: [{ id: "2", val: "微信登录", url: "wx_icon", name: "wxbind" }],
            certTypes: [], // 证件类型
            loginForm: {
                phone: "",
                password: "",
                smscode: "",
                verifyCode: "",
                certType: "00",
                certNo: ""
            },
            imgSrc: "",
            loginUser: "enduser",
            loginCertType: "",
            capsLock: false,
            rules: {
                phone: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                certType: [
                    {
                        required: true,
                        message: "请选择证件类型",
                        trigger: "change"
                    }
                ],
                certNo: [{ validator: this.checkCertNo, trigger: "change" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                smscode: [
                    {
                        validator: this.validateSmscode,
                        trigger: "blur"
                    }
                ],
                verifyCode: [
                    {
                        validator: this.$util.validateImgVerifyCode,
                        trigger: "blur"
                    }
                ]
            },
            /* wx跳转 */
            wxLoginParam: {},
            timer: "",
            count: -1,
            locked: false,
            loginloading: false,
            registerFlag: false,
            defaultImg: require("@/assets/img/login_banner.png"),
            dialogVisible: false,
            loading: false,
            singleLoginFlag: true
        };
    },
    computed: {
        span24() {
            return this.registerFlag ? "" : "span-24";
        }
    },
    created() {
        sessionStorage.setItem("alreadyread", "");
        this.singleLoginFlag = this.$util.getConfig().singleLogin;
        if (
            sessionStorage.getItem("NODE_ENV") &&
            sessionStorage.getItem("NODE_ENV") == "development"
        ) {
            this.singleLoginFlag = false;
        }
        this.getImgInfo();
        // if (this.singleLoginFlag) {
        //     this.$util.checklogin(() => {
        //         this.loading = false;
        //     });
        // }
        this.$cache.initCityCountyList();
        if (this.$util.getConfig().onlyPrivateFund) {
            this.loginType.length = 1;
        }
    },
    mounted() {
        document.body.onresize = (function (o) {
            return function () {
                o.setPageSize();
            };
        })(this);
        this.certTypes = JSON.parse(JSON.stringify(this.$cache.getDict("130007")));
        this.certTypes = this.certTypes.concat([
            {
                dictitem: "130007",
                subitem: "000",
                subitemname: "基金账号",
                sysid: "4"
            }
        ]);
        let findIndex = this.certTypes.findIndex((item) => item.subitem === `00`);
        if (findIndex >= 0) {
            this.certTypes[findIndex].subitemname = `身份证/手机号`;
        }
        if (
            this.$cache.getParams().function_mask &&
            this.$cache.getParams().function_mask.indexOf("0") > -1
        ) {
            this.loginType = this.loginType.filter((item) => {
                return item.id != "1";
            });
        }
        this.setPageSize();
        if (this.singleLoginFlag) return;
        // 前端心跳-每隔3分钟刷新验证码图片，以达到登录页面用不超时的效果
        this.imgRefresh = setInterval(
            (function (o) {
                return function () {
                    o.refresh();
                };
            })(this),
            3 * 60 * 1000
        );
        this.getUrlParam();
        this.checkEncWay();
        this.loginCertType = this.$util.getConfig().isPhoneLog ? "1" : "2";
        if (this.loginCertType === "2") {
            this.refresh();
        }
    },
    beforeDestroy() {
        clearInterval(this.imgRefresh);
    },
    methods: {
        // 查询现金宝信息
        async cfgFundrealtimeQueryAll() {
            let res = await fundApi.cfgFundrealtimeQueryAll();
            let xjbfundcode = res.data && res.data[0] && res.data[0].fundcode;
            const res1 = await fundApi.getFundLists({
                fundcode: xjbfundcode,
                pagesize: 10,
                pagenum: 1
            });
            let xjbFundInfo = res1.data.list && res1.data.list[0];
            sessionStorage.setItem("xjbFundInfo", JSON.stringify(xjbFundInfo));
        },
        /* 处理banner宽度和高度 */
        setPageSize() {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w = w < 1200 ? 1200 : w;
            this.ad_width = w;
            this.ad_height = w / this.ad_ratio;
            if (this.ad_height < 500) {
                this.ad_height = 500;
                this.ad_width = this.ad_height * this.ad_ratio;
            }
            // 登录表单位置计算
            this.login_top = (this.ad_height - 470) / 2;
        },
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            if (this.loginForm.certType === `00` && value.length === 11) {
                // 身份证号/手机号混合登录
                const regex = /^1[3-9]\d{9}$/;
                if (regex.test(value)) {
                    callback();
                } else {
                    callback(new Error(`请输入正确格式的手机号`));
                }
                return;
            }
            if (value === "") {
                callback(
                    new Error(
                        this.loginForm.certType === "000" ? "请输入基金账号" : "请输入证件号码"
                    )
                );
                return;
            }
            if (this.loginForm.certType !== "000") {
                this.$util.validateCertNo(rule, value, callback, this.loginForm.certType);
            } else {
                callback();
            }
        },
        /* 短信验证码 */
        validateSmscode(rule, value, callback) {
            if (value === "") {
                callback(new Error("请输入验证码"));
            } else {
                const reg = /^[0-9a-zA-Z]{6,6}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error("验证码应为6位数字"));
                }
            }
        },
        // 再次校验证件号码
        checkCertNoAgain() {
            this.$refs.loginForm.validateField("certNo");
        },
        // 判断是否开启大写输入
        detectCapsLock() {
            this.capsLock = this.$util.detectCapsLock();
        },
        /* 刷新验证码图片 */
        refresh() {
            this.$util.imgUrl().then((res) => {
                this.imgSrc = res.data.image;
            });
        },
        /* 跳转到忘记密码页面 */
        forgetPwd() {
            this.$router.push({
                name: "resetlogin",
                query: { tit: "找回密码" }
            });
        },
        /* 表单重置 */
        resetForm(formName) {
            this.$refs[formName].resetFields();
            // 解决表单切换
            this[formName].phone = "";
            this[formName].certNo = "";
            this[formName].password = "";
        },
        /* 表单登录 */
        login() {
            if (this.singleLoginFlag) {
                if (process.env.NODE_ENV === "development") {
                    /* 17324398226  1q2w3e4r测试  */
                    // sessionStorage.setItem(
                    //     "_a",
                    //     JSON.stringify({
                    //         token: "usertoken=100293177%7COIiHmEka4hs8hcP3HUrGehgV%2Be%2FHYmBEswRJsL45n%2FyFcWU%2FN8RguVSI7sM83D8DLahSeRTvLWQz5XT%2BIkVQVz63bm9nI6Lkl4m7r4WUsNDvotQdrNQU3kOCSYop%2FyAdzY9FPuh1NHAvQ2kzOV2h31VM7u1554bWuVLnYIEKgHMWFZwnA7Ghjo4SfDEX1VCpKgV2tncLckFWWLcn%2F5gP0CkllP7aSzNfmbnrefUzFmnaUD12fhG89dl%2FuBsZKaAfZrwhd3rBSxEW%2FsWRIu6YSGtTuFdS%2BFXynJsLoQRMHJBQNnyD2vNjQa6N9zpeBhIT4IXYxXUacZ6eWcsJYqD1k7IbD6tT45IFpRcODSaxjeU%3D;snapcookie=b5e4dffa9e3f32fcb59712c1eb93d669;"
                    //     })
                    // );

                    /* 13107385576  1q2w3e4r已开户 */
                    // sessionStorage.setItem(
                    //     "_a",
                    //     JSON.stringify({
                    //         token: "usertoken=100293343%7COIiHmEka4hsDSs2RTk9K9LENiVmn%2FU03%2F3TpMyICrRuU%2FQ8KhCtE8MvMlc9m2zIkxpr%2Fp%2FCkLCWgMCqhpgH97rupUJ4F0psMhsPWE5n2xI0aa3qTf2T0M2IQYW0nPHUdmfZUKMyARieSFZdRKGeVgQNeKxzCSkpB0YP%2Bya%2BDgjZE%2BLaJNXLpo%2F9ipGvGjfu59SbrHiIWbilcgp%2F1jasTFP4h1Ue%2B1HS85s08sUU4BMPlragpXMuWl%2BMUhOTrGzcJjkerWWU0DroeJ6%2Fe%2BYLxJFEmptXHK0hlEC%2FrY3W7sC%2BU3X876ZPit3oruOGJiorIfzs7AcTIfQ02itioHtPh5P%2BiKsFdJlwzRuy80yQwmJ7wBPfwwOhxP9YGHSY1x0UmIRvyH9YM2i6BxhnvGgEfdC3JW9tvuJRZhK1BbAv4Zbk5FR5ODQGvwQ%3D%3D;snapcookie=80bd153707953de68e2d8a132163256a;"
                    //     })
                    // );
                    /* 大王 */
                    // sessionStorage.setItem(
                    //     "_a",
                    //     JSON.stringify({
                    //         token: "usertoken=27420474%7COIiHmEka4hu5dK%2BC9EG%2BugBhN2Nj1QWIt06MzJ36egWndIK%2FpNHLjiqehVI%2BgY1L4VuA9W8ugoxS5GlU4v8o7S5vwiOHtvrK5%2FXDT%2FYsT52h7weSG00T%2BYVpGsb9ZgoY6%2B6sblzTJ%2FQNMxqix8la05u5ScyegsOpLprm%2B0NItg8lG4ft9ZTzXPRWlWErz8RW%2B03acQbXSNZX39i4jjSKyQPEQSQfcGvOLLtc%2FcNKTgxA7HgQsykPCxGmVKbTLBx8q0Ef7xdIFsAOGYydz6YVUPpCPVdYgRKWElNWd%2B1GOuYWuuIP9MFHg7p68SA4hlewj9wCSbiRPUBXuurccD%2F2VCCIU40tevTG;snapcookie=8654a24989ce3081b6a9f13215feb2fd;"
                    //     })
                    // );
                    // hk-aloha
                    // sessionStorage.setItem(
                    //     "_a",
                    //     JSON.stringify({
                    //         token: "usertoken=100293177%7COIiHmEka4hvA0YPNIjRRlp6IvglHOmyhqELepTX1AZ3KGcbgPJoK9zs%2Bw2wgi92aV17m1g%2BsFqkNpcQfXy9DGqgiOLOM5eERnfriZkYsbPxvdRjPgPuDyhvfyougoRgacNPfzPJ47p3xZdYm5E11vjZL9qq6PrJyVeIhzmLjgrJI70XporWSDoeBADb%2FESV8cMrUt17lmGZQNNY66uMh3NOLYk3xiPHykD%2FCZsl%2BIjOlK0c3skWQxTbNhDT029R490mB9TeAfHboH0at7AzW5nGaA7N0719ISOjy9eSv5YdwSz5D3FY3nll%2FZ%2FqwOA62Hr69aIFkmD0QEfWj7wxAUtnsdoCq5VIM;snapcookie=e13d177c015b37469376f93c2391d4b4;"
                    //     })
                    // );
                    /* 弘康个人网交 丽丽 */
                    // sessionStorage.setItem(
                    //     "_a",
                    //     JSON.stringify({
                    //         token: "usertoken=100293347%7COIiHmEka4hsCIbrOMpfUzSQtT3MS71rQ5ISwIHAxww1TEyMgdLWN3pNXiGSxPdRG%2FfW3yYP5%2BBdHkXLKjxL5TZcFvKlqM7pLF1ZxovAe6RpYcez8wai1yg64xp%2BnxlhZnO9wUVuSmTyIlm4xlvZdNgGGLt1ZMl%2F4rFQ6OJxO4Y%2BDIQUNUFaTJR6g2kZ86UFh3FEZL4OaxxgoblITUAVH6RZlJt3jeuWSaHOxyy57HCYVv1jlo8GbIlPsHAld08PkrPcTRiYQTNwh2SYif1rQcd15cRwUOpkLwDgNSmS7XBnD%2BmdO3%2FLLV87%2F6PHeM3rQ%2FhYnfN8AFnIR7Xh0BBRPksizsBRO2QMpDdjS68HAW3xyRtTD3UDoHTHA45Uhf2ZXHmCfv4o5%2Fqf9E6VmMkU%2Frd3GDMmMi%2F1Jjzh7va1iVGkHDC7fWdA0Co3czz9hyGm3cr4Fj7Xj6MSxI4WklMI6J8f%2FOxhQUyKkwjiduY5%2BmcTIfnomK%2BfuNxex6wfpte16GDLa8OLs%2Fy%2FWNgt3adTA41noTVZFQk%2FMYWsDbSsDFgHQsk6W16ZpfA3kS39ae%2FuWgNw%2BYS28yp4XFxkOWlhe4vkVfWbJigqKPK6dKC74xBdN2qkKYEDKBA%2BEtq6U7Rln9Pf%2FOUanb7H0fFoWeUGR1HpP7VHRg6XhVLU9z89XjLwFpdlib9vN2EWmI69wfjbubQNSU%2FcUjdktNORYn%2Bhf2%2BeY1hpkI%2BCA0lq6jvgGJUMN61%2F%2BP8S4abVNU1N%2BwDBAWC00wjoR1MwnPn7ytipCv0qUOIhLKuXXQZtE4oz2dMtbsfw0obNxgYfMx0JAAaZQih5ThlIQ6uqh3jO2mP2YAiN%2FtcJZW0qxHk6LMcFOdOUx8CzGGybn2zn%2BAUOoHwUIWsNLtXpltva3jOxNThfkUvDuG0TCjwq6kDbUtUadBxNvFxgKG3dNY5GWyL6Ys25%2F;snapcookie=23870b24d4d737588dd4f634ec7fb4a0;"
                    //     })
                    // );
                    /* 现场测试环境 满运峰 */
                    sessionStorage.setItem(
                        "_a",
                        JSON.stringify({
                            token: "usertoken=27399333%7COIiHmEka4huZvstOb8PpGc3Aj1nL8LDQ9JpY7MJqPrJ4hb3030v5urtK3aDVMlKaHPDmMCsphnCq50eLonJ8S%2BaRMuUP9whuX%2FuQIY9sFt4YM4LJp59klCSG2V5GNCmBEwZ3qQVkeeQRk8C3jR3ft88ntCGvzKarTMppFOY%2BkVa3lXyoz%2FmYFYVn6jhi%2B%2F1MDXWc5zhiGa2kPZ4GXLHc2hgkTy97BRguhj98hS8ArAwuIjSVc1hMlg%2B2SgRY%2B47v%2F023ZtbQ3%2FAvKZ7MumR1Si173S%2F4ooUJ0GfNowg4rJjUU%2FD1U5LfWAKuacLisag9GDVoltFiX%2Fpe%2FUJ0ueq8EnUKMIDWsv7fPMJTSXjFbPM%3D;snapcookie=0fb5eb035ede3be881fb08c904b1148a;"
                        })
                    );
                    /* 现场测试环境 17324398226  注册用户 */
                    // sessionStorage.setItem(
                    //     "_a",
                    //     JSON.stringify({
                    //         token: "usertoken=100293177%7COIiHmEka4huAyFK2flPXQ8W0onyDPfQ1obnnMoYZW6tfQ2LUKb65Tdkbs%2FbJUWIV13uYNcFuAitZcS%2F1QmH4TXt1bDXd6r8hDsjxHCcPpwGU5iswDk4jog14xymQHZjsnXZkaesNZgMeuxN%2FV7pxIX3LXpFPqhjHvNyhi4ukmPtGNQguHGMC1ouI8klEPz0Y0PhIpJgijGDY5Dk8Yq%2FV6KekzwMPO7Qbmb%2BtBi8fTyM6MXHxdHw%2FJCkf5w9gev2ME4EJPHRL0lgIZRNUS6EZQaD8A7xNqzq%2F9QuMdEhebdo%2FMswZ74iuMhMMMok2BS%2B84Qo2hFriSzKN6J7BppE3EHrMHCLAVpsyJ4A57%2B1vSpQ%3D;snapcookie=ebad382aaba6348186c394312138c4df;"
                    //     })
                    // );
                    this.$util.singleLogin();
                } else {
                    this.$util.goToHxLogin();
                }
                return;
            }
            if (this.loginloading) return;
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.formValidSuccess();
                    return false;
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 快捷注册 */
        register() {
            if (this.loginUser === "enduser") {
                this.$router.push({
                    name: "register",
                    query: { tit: "快速开户" }
                });
            }
        },
        async getImgInfo() {
            let info = this.$cache.getParams();
            let bannerList;
            try {
                bannerList = JSON.parse(info["10105001"].paramvalue);
            } catch (e) {
                console.log(e);
            }
            // cacheData._params['10105001']
            // bannerList = res.data.list;
            for (let i in bannerList) {
                bannerList[i].imgid = this.$util.imgSrc({
                    fileCode: bannerList[i].fileid
                });
            }
            this.ads = bannerList;
        },
        getVerifyCode(val) {
            if (this.count > 0) return;
            this.$util.validateMobile("", this.loginForm.phone, async (err) => {
                if (!err) {
                    if (this.$cache.getSysParam("10103010") == "2") {
                        this.sendSms("1");
                    } else {
                        this.dialogVisible = true;
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: err.message
                    });
                }
            });
        },
        sendSms(val) {
            this.dialogVisible = false;
            if (!val) return;
            this.$util.validateMobile("", this.loginForm.phone, async (err) => {
                if (!err) {
                    try {
                        const { data } = await userApi.loginSms(
                            {
                                mobileno: this.loginForm.phone,
                                verifycode: val
                            }
                            // 示例：如果想要某些返回码也通过校验，通过自定义validateCode配置项实现
                            // {
                            //     validateCode: (code) => {
                            //         return code === 0 || code === "0";
                            //     },
                            // }
                        );
                        this.locked = true;
                        this.count = data.sendperiod;
                        this.counting();
                        this.$message({
                            type: "success",
                            message: "验证码已发送"
                        });
                    } catch (e) {
                        this.refresh();
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: err.message
                    });
                }
            });
        },
        /* 登录表单验证成功 */
        async formValidSuccess() {
            if (!this.locked && this.loginCertType === "1") {
                this.$message({
                    type: "warning",
                    message: "请先发送手机短信验证码"
                });
                return false;
            }
            const loginPwd = this.$util.enc(this.loginForm.password);
            let accttype = "";
            if (this.loginCertType === "1") {
                // 手机短信登录
                accttype = "8";
            }
            if (this.loginCertType === "2") {
                accttype = this.loginForm.certType === "000" ? "2" : "0";
            }
            let _data = {
                accttype: accttype,
                logintype: this.loginCertType === "1" ? "02" : "05",
                certificatetype: this.loginForm.certType === "000" ? "" : this.loginForm.certType,
                certificateno: this.loginForm.certNo,
                verifycode: this.loginForm.verifyCode,
                smscode: this.loginForm.smscode,
                pwd: loginPwd,
                mobileno: this.loginForm.phone
            };
            // 校验手机号登录方式
            const regex = /^1[3-9]\d{9}$/;
            if (regex.test(this.loginForm.certNo) && this.loginCertType === "2") {
                _data.logintype = `05`;
                _data.certificatetype = ``;
                _data.certificateno = ``;
                _data.accttype = `8`;
                _data.mobileno = this.loginForm.certNo;
            }
            try {
                this.loginloading = true;
                const res = await userApi.login(_data);
                if (res.error) {
                    this.loginloading = false;
                    return;
                }
                // 查询现金宝信息
                this.cfgFundrealtimeQueryAll();
                const { data } = res;
                this.$cache.setBinded(data.others.isbind === "1");
                this.$cache.setHeadImage(data.others.headimage ? data.others.headimage : "");
                this.$cache.setUserOtherInfo(data.others);
                try {
                    sessionStorage.setItem("custbelongto", data.others.custbelongto);
                    sessionStorage.setItem("custnoCrm", data.others.custnoCrm);
                } catch (error) {
                    this.$log.error(error);
                }
                this.$store
                    .dispatch("login", {
                        key: this.loginForm.phone,
                        ...JSON.parse(sessionStorage.getItem("_a") || "{}"),
                        userinfo: data.others,
                        userName: data.userName
                    })
                    .then(() => {
                        if (data.others.isbind === "1") {
                            this.$router.push("/home");
                        } else {
                            if (this.singleLoginFlag) {
                                this.$router.push("/home");
                            } else {
                                this.$alert(
                                    "您的账户尚未开户，暂时无法进行购买/定投基金等交易功能，是否立即前往开户",
                                    "温馨提示",
                                    {
                                        confirmButtonText: "确定",
                                        type: "warning"
                                    }
                                )
                                    .then(() => {
                                        this.$router.push({
                                            name: "bindacctway"
                                        });
                                    })
                                    .catch(() => {
                                        this.$router.push("/home");
                                    });
                            }
                        }
                    })
                    .catch((e) => {
                        this.loginloading = false;
                        console.log("login error", e);
                    });
            } catch (e) {
                this.loginloading = false;
                this.refresh();
            }
        },
        loginFromWX(list) {
            // this.$router.push({name: list.name});
            if (this.loginUser === "enduser") {
                let backurl = encodeURIComponent(window.location.href);
                let appid = this.$cache.getCompanyInfo().wechat_web_appid || "";
                window.location.href =
                    "https://open.weixin.qq.com/connect/qrconnect?appid=" +
                    this.$cache.getCompanyInfo().wechat_web_appid +
                    "&redirect_uri=" +
                    backurl +
                    "&response_type=code&scope=snsapi_login&state=" +
                    this.$cache.getSessionToken() +
                    "#wechat_redirect";
            }
        },
        // 获取URL查询参数
        getUrlParam() {
            var queryStr = location.href;
            var targetUrl = queryStr.substr(queryStr.indexOf("?") + 1).split("&");
            targetUrl.forEach((f) => {
                this.$set(this.wxLoginParam, f.split("=")[0], f.split("=")[1]);
            });
            if (this.wxLoginParam.code) this.wxlogin();
        },
        // wx是否绑定，是否直接微信登录
        wxlogin() {
            const _this = this;
            this.$req({
                url: "/oauth/wechat",
                data: this.wxLoginParam,
                method: "POST"
            })
                .then((res) => {
                    // 绑定状态
                    if (res.code === "0000000") {
                        if (res.record[0][0].bound === "0") {
                            _this.$router.push({ name: "wxbind" });
                        } else {
                            _this.$store
                                .dispatch("login", {
                                    key: res.record[0][0].aeskey,
                                    token: res.record[0][0].token
                                })
                                .then(() => {
                                    _this.$router.push("/home");
                                });
                        }
                    } else {
                        _this.refresh();
                        _this.$message({
                            type: "warning",
                            message: res.msg
                        });
                    }
                })
                .catch(() => {
                    _this.refresh();
                });
        },
        /* 查看柜台是否开启国密 */
        checkEncWay() {
            sessionStorage.setItem("isOpenGMEnc", "0");
            sessionStorage.setItem("hasBankRroute", "0");
            /* this.$util.getGtParamsValue ("1001164",res => {
                if(res.paramvalue.indexOf("A90") > -1) {
                    sessionStorage.setItem("isOpenGMEnc", "1");
                }else {
                    sessionStorage.setItem("isOpenGMEnc", "0");
                }
                if(res.paramvalue.indexOf("A32") > -1) {
                    sessionStorage.setItem("hasBankRroute", "1");
                }else {
                    sessionStorage.setItem("hasBankRroute", "0");
                }
            }); */
        },
        counting() {
            if (this.timer) this.timer = null;
            this.timer = setInterval(() => {
                if (this.count > 0) {
                    this.count -= 1;
                }
            }, 1000);
        },
        // 加载默认图片
        handleError(e) {
            e.target.src = this.defaultImg;
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.view-login {
    position: relative;
    .login-bg {
        top: 134.67px;
        width: 100%;
        height: 586px;
        position: absolute;
        z-index: 0;
    }
    .flex-d {
        flex-direction: column;
        align-items: center;
        margin: 12px 0 24px;
    }
    .h545 {
        height: 545px;
    }
    .login-main {
        padding: 16px 0;
        width: 1242px;
        margin: 12px auto 24px;
        display: flex;
        justify-content: space-around; /* 设置水平方向上子元素的分布 */
        /*gap: 24px;*/
        .login-comp-container {
            position: relative;
            .login-panel {
                box-shadow: 0 0 5px $border-color2;
                width: 380px;
                height: 468px;
                z-index: 999;
                background: $bg2;
                padding: 0;
                border-radius: 6px 6px;
                overflow: hidden;
                .el-tabs__content {
                    background-color: #f9f9f9;
                }
                .el-tabs__header.is-top {
                    margin: 0;
                }
                .el-tabs__nav-wrap.is-scrollable {
                    padding: 0;
                }
                .el-tabs__active-bar {
                    /*width: 180px !important;*/
                    background: $bg18;
                }
                .el-tabs__item {
                    width: 380px;
                    padding: 0;
                    font-size: 20px;
                    color: $text-color3;
                    text-align: center;
                    &.is-active {
                        color: $color-a;
                    }
                }
                .login-cert-type {
                    background: $bg1;
                    height: 46px;
                    padding: 0 12px;
                    display: flex;
                    line-height: 46px;
                    align-items: center;
                    justify-content: center;
                    .left-btn,
                    .right-btn {
                        padding: 0 12px;
                        flex: 1;
                        font-family: Source Han Sans CN;
                        font-size: 18px;
                        color: #999999;
                        cursor: not-allowed;
                        user-select: none;
                    }
                    .left-btn {
                        text-align: right;
                    }
                    .middle-line {
                        width: 2px;
                        height: 25px;
                        background-color: #e4e4e4;
                    }
                    .select-btn {
                        color: #e60012;
                        font-weight: bold;
                        cursor: pointer;
                    }
                    .el-radio {
                        display: inline-block;
                        width: 156px;
                        margin-right: 0;
                        text-align: left;
                        padding-left: 24px;
                        .el-radio__label {
                            line-height: 24px;
                            font-size: 16px;
                        }
                        .el-radio__input.is-checked + .el-radio__label {
                            color: $text-color2;
                        }
                    }
                    .el-radio + .el-radio {
                        margin: 0;
                    }
                }
                .login-other {
                    padding: 15px 10px 15px 13px;
                    .login-other-box {
                        display: inline-block;
                        .other-list {
                            cursor: pointer;
                            margin-right: 20px;
                            display: inline-block;
                            .other-list-img {
                                vertical-align: middle;
                                width: 23px;
                                height: 23px;
                                display: inline-block;
                            }
                            .other-list-text {
                                color: $text-color3;
                                margin-left: 5px;
                                vertical-align: middle;
                            }
                        }
                    }
                    .login-btn-msg {
                        display: inline-block;
                        vertical-align: middle;
                        color: $text-color1;
                        .d-login {
                            color: $color-b;
                            // float: right;
                            padding: 0;
                            span {
                                line-height: 23px;
                                display: inline-block;
                            }
                        }
                    }
                }
                .login-form {
                    background: $bg2;
                    .span-24 {
                        min-width: 330px !important;
                    }
                    padding: 10px 15px 0;
                    .el-form-item {
                        margin-bottom: 16px;
                        &.icon-select {
                            position: relative;
                        }
                        &.login-btn {
                            padding: 5px 0 10px 0;
                            text-align: center;
                            margin-bottom: 0;
                            .login-n {
                                // float: left;
                                font-size: $f16;
                                min-width: 150px;
                            }
                            .quick {
                                color: $color-a;
                                font-size: $f16;
                                float: right;
                                min-width: 150px;
                            }
                        }
                        .fa.fa-id-card.select-card {
                            position: absolute;
                            z-index: 1000;
                            font-size: $f20;
                            color: #c0c4cc;
                            top: 11px;
                            left: 6px;
                        }
                        .el-select {
                            width: 350px;
                            .el-input__inner {
                                padding-left: 40px;
                            }
                        }
                        .el-input {
                            border-bottom: 1px solid $border-color5;
                            .el-input__inner {
                                border: none;
                                border-radius: 0;
                                padding-left: 40px;
                            }
                            .el-input__icon {
                                font-size: $f20;
                                // color:
                            }
                        }
                        .el-form-item__error {
                            width: 100%;
                            text-indent: 40px;
                            //background: $bg6;
                            font-size: $f14;
                            color: $color-c;
                            padding: 4px 0;
                            z-index: 2;
                            font-family: "element-icons", sans-serif !important;
                            font-style: normal;
                            font-weight: normal;
                            font-variant: normal;
                            text-transform: none;
                            line-height: 1;
                            vertical-align: baseline;
                            display: inline-block;
                            -webkit-font-smoothing: antialiased;
                            -moz-osx-font-smoothing: grayscale;
                        }
                        .el-col.el-col-19 {
                            .el-form-item--small.el-form-item {
                                margin-bottom: 0px;
                            }
                        }
                        .reset-pwd .el-input-group__append {
                            width: 38px;
                        }
                        .el-input-group__append {
                            color: $color-a;
                            border: none;
                            background: none;
                            padding: 0;
                            cursor: pointer;
                            .reset-btn {
                                padding: 0;
                            }
                            .grey {
                                color: grey;
                            }
                            .prop-verify {
                                height: 38px;
                                float: right;
                            }
                        }
                    }
                }
            }
        }
        .el-carousel {
            width: 817px;
            height: 468px;
            overflow: hidden;
            margin: 0 auto;
        }
    }
    .singleLogin {
        z-index: 1;
        height: 82px;
        width: 817px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        .login-n {
            font-size: $f16;
            min-width: 180px;
            height: 42px;
        }
    }
}
.dc-other-container {
    /*margin-top: 12px;*/
    display: flex;
    width: calc(100% - 0px);
    justify-content: space-around; /* 设置水平方向上子元素的分布 */
    gap: 24px;
    .otheritem {
        flex: 1;
        font-size: 12px;
        color: #999;
        background-color: #f9f9f9;
        border-radius: 2px;
        cursor: pointer;
        &:hover {
            color: #333;
        }
    }
}
.margin-top12 {
    margin-top: 12px;
}
#verifyImg {
    width: 112px;
    height: 38px;
}
</style>
